//This hook is used to get data from Firebase
import { useState, useEffect, useRef } from "react"

import { collection, onSnapshot, query, where, orderBy} from "firebase/firestore"; 
import { db } from "../firebase/config"

export const useCollection = (collections, _query,_orderBy) => {
    const[document,setDocument] = useState(null)
    const[error, setError] = useState(null)
    const[pending, setIspending] = useState(false)

    //if we don't use a ref hook --> infinite loop in useEffect
    //_query is an array and is a reference type. It considers the _query value a s different in every function call
    const query1 = useRef(_query).current
    const orderBy1 = useRef(_orderBy).current

    useEffect(() => {
    //collection ref
    let ref= collection(db, collections)
    setIspending(true)

    if (query1 && orderBy1) {
       let ref1 =  query(ref, orderBy(...orderBy1), where(...query1))
       const unsubscribe = onSnapshot(ref1, (snapshot) => {
        let results = []
        snapshot.docs.forEach(doc => {
            results.push({...doc.data(),id: doc.id})
        })
        //update state
        setDocument(results)
        setError(null)
        setIspending(false)
    },(error) => {
        setError('Couldnot fetch data')
        setIspending(false)
        console.log(error.message)
    })
        //unsubscribe on unmount
        return () => unsubscribe()   
    }else{
        
       const unsubscribe = onSnapshot(ref, (snapshot) => {
        let results = []
        snapshot.docs.forEach(doc => {
            results.push({...doc.data(),id: doc.id})
        })
        //update state
        setDocument(results)
        setError(null)
        setIspending(false)
    },(error) => {
        setError('Couldnot fetch data')
        setIspending(false)
        console.log(error.message)
    })
        //unsubscribe on unmount
        return () => unsubscribe()  
    }
    },[collections, query1, orderBy1])

    return{document, error, pending}

}
